import { render } from "./BusinessHomePage.vue?vue&type=template&id=cfeeb874"
import script from "./BusinessHomePage.vue?vue&type=script&lang=js"
export * from "./BusinessHomePage.vue?vue&type=script&lang=js"

import "./BusinessHomePage.vue?vue&type=style&index=0&id=cfeeb874&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__